import * as types from './actionTypes';  
import underwriterPerformanceApi from '../api/underwriterPerformanceApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doUnderwriterPerformance(request) {

  return {
    type: types.DO_UNDERWRITER_PERFORMANCE, 
    request
  };
}

export function doUnderwriterPerformanceRes(data) {  
  return {
    type: types.DO_UNDERWRITER_PERFORMANCE_RES, 
    data
  };
}

export function getUnderwriterPerformance(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      underwriterPerformanceApi.doUnderwriterPerformance(request).then(data => {
        dispatch(doUnderwriterPerformanceRes(data));
        dispatch(doUnderwriterPerformanceRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}